import { noop } from 'lodash';
import { useMemo } from 'react';

import { CurrentHealthcareProviderInvoiceQuery, Invoice } from '@dreryk/egabinet-invoice-frontend-api';

import {
   LazyLoadedDataConfigurationByCqrsQuery,
   useLazyLoadedDataConfigurationByCqrsQuery,
} from '@dreryk/drerykweb-main-frontend';
import { dateFormatter, stringFormatter, Translate } from '@dreryk/react-common';
import {
   createDynamicColumnsWidth,
   dispatchSnackbarNegativeEvent,
   HorizontalAlign,
   JustifyContent,
   TableColumnConfiguration,
} from '@dreryk/react-components';

import { issuedInvoicesTranslationKeys } from '../../translations';

import { IssuedInvoicesTablePriceCell } from './cells/IssuedInvoicesTablePriceCell';

export const useIssuedInvoiceDataConfiguration = (): LazyLoadedDataConfigurationByCqrsQuery<Invoice> => {
   return useLazyLoadedDataConfigurationByCqrsQuery<Invoice>(
      () => new CurrentHealthcareProviderInvoiceQuery(),
      undefined,
      {
         onUnexpectedError: () => dispatchSnackbarNegativeEvent(issuedInvoicesTranslationKeys.downloadFault),
      }
   );
};

export const useIssuedInvoicesTableColumns = (): TableColumnConfiguration<Invoice>[] => {
   return useMemo(() => {
      const columnsWidth = createDynamicColumnsWidth({
         issuedDate: '180px',
         invoiceType: '180px',
         number: '180px',
         grossPrice: '180px',
         buyer: '100%',
      });

      return [
         {
            name: 'issuedDate',
            label: issuedInvoicesTranslationKeys.table.issuedDate,
            accessor: 'issuedDate',
            width: columnsWidth.issuedDate,
            sortingDisabled: true,
            formatter: dateFormatter,
         },
         {
            name: 'invoiceType',
            label: issuedInvoicesTranslationKeys.table.invoiceType,
            accessor: 'invoiceType',
            width: columnsWidth.invoiceType,
            sortingDisabled: true,

            renderer: ({ bean }) => <Translate>{issuedInvoicesTranslationKeys.table.type[bean.invoiceType]}</Translate>,
         },
         {
            name: 'number',
            label: issuedInvoicesTranslationKeys.table.invoiceNumber,
            accessor: 'number',
            width: columnsWidth.number,
            sortingDisabled: true,
            formatter: stringFormatter,
         },
         {
            name: 'grossPrice',
            label: issuedInvoicesTranslationKeys.table.grossPrice,
            justifyContent: JustifyContent.END,
            textAlign: HorizontalAlign.RIGHT,
            accessor: 'grossPrice',
            width: columnsWidth.grossPrice,
            sortingDisabled: true,

            renderer: ({ bean }) => <IssuedInvoicesTablePriceCell grossPrice={bean.grossPrice} />,
         },
         {
            name: 'buyer',
            label: issuedInvoicesTranslationKeys.table.buyer,
            accessor: noop,
            width: columnsWidth.buyer,
            sortingDisabled: true,

            renderer: ({ bean }) => (
               <>{bean.companyName ? bean.companyName : `${bean.buyerLastName} ${bean.buyerFirstName}`}</>
            ),
         },
      ];
   }, []);
};
